import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { routePath } from "@/i18n/routes";
import { Kicker, PageHero, Section } from "@/components/Primitives";
import { Button } from "@/components/ui/button";

export default function Opportunities() {
  const { t, lang } = useI18n();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api
      .get("/public/opportunity-categories")
      .then(({ data }) => setCategories(data.categories || []))
      .catch(() => setCategories([]));
  }, []);

  return (
    <div data-testid="opportunities-page">
      <Seo pageKey="opportunities" />
      <PageHero kicker={t("opportunities.kicker")} title={t("opportunities.title")} lead={t("opportunities.lead")} />

      <Section>
        <Kicker>{t("opportunities.categoriesTitle")}</Kicker>
        <div data-testid="opportunity-categories" className="mt-10 grid grid-cols-1 gap-px border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <article key={cat.key} data-testid={`opportunity-${cat.key}`} className="bg-surface p-8 transition-colors duration-300 hover:bg-muted">
              <p className="cs-kicker text-accent">{t(`verticals.${cat.vertical}`)}</p>
              <h2 className="mt-4 font-display text-2xl font-medium">{t(`opportunities.cats.${cat.key}.title`)}</h2>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{t(`opportunities.cats.${cat.key}.body`)}</p>
            </article>
          ))}
        </div>
        <p data-testid="opportunities-note" className="mt-10 max-w-3xl border-l-2 border-accent pl-6 text-sm text-muted-foreground">
          {t("opportunities.note")}
        </p>
        <div className="mt-12 flex flex-col gap-4 sm:flex-row">
          <Button asChild size="lg" data-testid="opportunities-apply-cta" className="rounded-full bg-accent px-8 text-accent-foreground hover:bg-accent/90">
            <Link to={routePath("apply", lang)}>{t("cta.apply")}</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full px-8" data-testid="opportunities-contact-cta">
            <Link to={routePath("contact", lang)}>{t("cta.talk")}</Link>
          </Button>
        </div>
      </Section>
    </div>
  );
}
